import {useCallback, useEffect, useState} from "react";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindconfig from "../tailwind.config";
import {ExtendedTailwindConfig} from "../ExtendedTailwindConfig.interface";

export enum Screen {
	sm = "sm",
	md = "md",
	lg = "lg",
	xl = "xl",
	"2xl" = "2xl",
}

export enum ScreenNumber {
	sm = 0,
	md = 1,
	lg = 2,
	xl = 3,
	"2xl" = 4,
}

const getCurrentScreen = (width: number) => {
	const config = resolveConfig(tailwindconfig) as ExtendedTailwindConfig;

	const sm = parseInt(config.theme.screens.sm.split("px")[0]);
	const md = parseInt(config.theme.screens.md.split("px")[0]);
	const lg = parseInt(config.theme.screens.lg.split("px")[0]);
	const xl = parseInt(config.theme.screens.xl.split("px")[0]);
	const xxl = parseInt(config.theme.screens["2xl"].split("px")[0]);

	if (width < sm) {
		return Screen.sm;
	} else if (width >= sm && width < md) {
		return Screen.md;
	} else if (width >= md && width < lg) {
		return Screen.lg;
	} else if (width >= lg && width < xl) {
		return Screen.xl;
	} else if (width >= xl && width < xxl) {
		return Screen["2xl"];
	} else {
		return Screen["2xl"];
	}
};

const getCurrentScreenAsNumber = (screen: Screen) => {
	switch (screen) {
		case Screen.sm:
			return 0;
		case Screen.md:
			return 1;
		case Screen.lg:
			return 2;
		case Screen.xl:
			return 3;
		case Screen["2xl"]:
			return 4;
		default:
			return 4;
	}
};

export const useMediaQuery = () => {
	const [currentScreen, setCurrentScreen] = useState<Screen | null>();
	const [currentScreenAsNumber, setCurrentScreenAsNumber] =
		useState<ScreenNumber>(2);
	const config = resolveConfig(tailwindconfig) as ExtendedTailwindConfig;

	// BUG: returns 1 if loaded for first time (only after resizing it starts giving correct values)
	// IDEA: after window availabele

	const calcCurrentScreen = useCallback(() => {
		const currentScreen = getCurrentScreen(window.innerWidth);
		setCurrentScreen(currentScreen);
		setCurrentScreenAsNumber(getCurrentScreenAsNumber(currentScreen));
	}, []);

	useEffect(() => {
		// add "resize" -> "onloadfirsttije"
		calcCurrentScreen();
		window.addEventListener("resize", calcCurrentScreen);
		return () => window.removeEventListener("resize", calcCurrentScreen);
	}, []);
	return {
		currentScreen: currentScreen,
		currentScreenAsNumber: currentScreenAsNumber,
	};
};
